import React from "react";
import classnames from "classnames";
import { Tooltip } from "@whatslly/ui-components/Tooltip";
import { Checkbox } from "@whatslly/ui-components/v2/Checkbox";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

export interface MessageCheckboxStore {
  value: boolean;
  disabled?: boolean;
  showDisableTooltip?: boolean;
  update: (checked: boolean) => void;
  testId?: string;
}
const STYLES = {
  messageCheckbox: "whatslly-messageCheckbox",
  entireDayCheckbox: "whatslly-entireDayCheckbox",
};

export const MessageCheckbox: React.FC<{ store: MessageCheckboxStore }> = observer(({ store }) => {
  const { t } = useTranslation();
  return (
    <Tooltip value={store.showDisableTooltip ? t("selective_sync.max_suppot") : undefined} placement="left">
      <div className={STYLES.messageCheckbox}>
        <Checkbox
          testId={store.testId}
          size="large"
          value={store.value}
          disabled={store.disabled}
          onChange={(e) => store.update(e.currentTarget.checked)}
        />
      </div>
    </Tooltip>
  );
});

export interface EntireDayCheckboxStore {
  title: string;
  value: boolean;
  disabled?: boolean;
  update: (checked: boolean) => void;
}

export const EntireDayCheckbox: React.FC<{ store: EntireDayCheckboxStore }> = observer(({ store }) => {
  const { t } = useTranslation();

  return (
    <Tooltip value={t("select_all_day_messages", { day: store.title.toLowerCase() })} placement="left">
      <div className={classnames(STYLES.messageCheckbox, STYLES.entireDayCheckbox)}>
        <Checkbox size="large" value={store.value} onChange={(e) => store.update(e.currentTarget.checked)} disabled={store.disabled} />
      </div>
    </Tooltip>
  );
});
